import { Card } from '@mantine/core'
import { useParams } from 'react-router-dom'

import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'
import BasicTemplate from 'src/v2/commons/templates/BasicTemplate'

import ClinicDoctors from '../components/ClinicDoctors/ClinicDoctors.component'
import ClinicInformation from '../components/ClinicInformation/ClinicInformation.component'
import ClinicLocations from '../components/ClinicLocations/ClinicLocations.component'
import { useSingleClinic } from '../hooks/useSingleClinic.hook'

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Team Lead Hub' },
  { title: 'Clinic' },
]

const SingleClinicView = () => {
  const { clinicId = '' } = useParams<{ clinicId: string }>()

  const {
    editMode,
    clinicForm,
    clinicLocations,
    clinicProviders,
    setEditMode,
    submitForm,
    cancelEdit,
    isLoading,
    isLoadingUpdate,
  } = useSingleClinic(clinicId)

  return (
    <BasicTemplate
      isLoading={isLoading}
      title={clinicForm.getValues().name}
      breadCrumbItems={breadCrumbItems}
    >
      <Card shadow="lg" radius="sm">
        <ClinicInformation
          onSubmit={submitForm}
          editForm={editMode}
          setEditForm={setEditMode}
          clinicInformationForm={clinicForm}
          handleCancelForm={cancelEdit}
          loading={isLoadingUpdate}
          clinicId={clinicId}
        />

        <ClinicLocations
          clinicName={clinicForm.getValues().name}
          clinicId={clinicId}
          locations={clinicLocations}
        />

        <ClinicDoctors
          providers={clinicProviders}
          clinicId={clinicId}
          clinicName={clinicForm.getValues().name}
        />
      </Card>
    </BasicTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  SingleClinicView,
  'is_get_roles_enabled',
  true,
)
